module.exports = __webpack_public_path__ + "2d28625ca5ee6164769813c7699d4d90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/yichan/yichan-bg.jpg
// module id = 1256
// module chunks = 0